module.exports = __webpack_public_path__ + "static/media/hand-holding-usd.a75afc0e.svg";